/* Copyright (c) 2021-2022 Nordcloud Oy or its affiliates. All Rights Reserved. */

import { CustomerCategory, CustomerCategoryDisplay } from "../models";

export const customerCategoryList = [
  {
    label: CustomerCategoryDisplay.MCC,
    value: CustomerCategory.MCC,
  },
  {
    label: CustomerCategoryDisplay.MCE,
    value: CustomerCategory.MCE,
  },
  {
    label: CustomerCategoryDisplay.MCA,
    value: CustomerCategory.MCA,
  },
  {
    label: CustomerCategoryDisplay.SAAS,
    value: CustomerCategory.SAAS,
  },
  {
    label: CustomerCategoryDisplay.LANDING_ZONE,
    value: CustomerCategory.LANDING_ZONE,
  },
  {
    label: CustomerCategoryDisplay.L1,
    value: CustomerCategory.L1,
  },
  {
    label: CustomerCategoryDisplay.CSM,
    value: CustomerCategory.CSM,
  },
  {
    label: CustomerCategoryDisplay.ONBOARD,
    value: CustomerCategory.ONBOARD,
  },
  {
    label: CustomerCategoryDisplay.CPS,
    value: CustomerCategory.CPS,
  },
  {
    label: CustomerCategoryDisplay.MCDB,
    value: CustomerCategory.MCDB,
  },
  {
    label: CustomerCategoryDisplay.MCO_OPENSHIFT,
    value: CustomerCategory.MCO_OPENSHIFT,
  },
  {
    label: CustomerCategoryDisplay.MCO_K8S,
    value: CustomerCategory.MCO_K8S,
  },
  {
    label: CustomerCategoryDisplay.MFO,
    value: CustomerCategory.MFO,
  },
  {
    label: CustomerCategoryDisplay.MVM,
    value: CustomerCategory.MVM,
  },
  {
    label: CustomerCategoryDisplay.SAP,
    value: CustomerCategory.SAP,
  },
];

export const serviceLineList = [
  { label: "Managed Cloud Capacity", value: "MCC" },
  { label: "Managed Cloud Environments", value: "MCE" },
  { label: "Managed Cloud Applications", value: "MCA" },
  { label: "Managed Containers", value: "MCO" },
  { label: "Managed Cloud Environments Security", value: "MCES" },
  { label: "Managed Cloud Landing Zones", value: "MCLZ" },
  { label: "Managed Cloud Databases", value: "MCDB" },
  { label: "Managed VMware", value: "MVM" },
  { label: "Managed Virtual Desktop Infrastructure", value: "MVD" },
  { label: "Managed Cloud Environments Networking", value: "MCEN" },
  { label: "Managed FinOps", value: "MFO" },
  {
    label: "[IBM] Application Management Support - Finnair",
    value: "[IBM] AMS",
  },
  { label: "Managed Cloud Security Services", value: "MCSS" },
  { label: "Managed SAP", value: "MSAP" },
  { label: "Managed Vulnerability Service", value: "MVS" },
  { label: "Managed IBM Software and Assets", value: "MISA" },
  { label: "Managed Data", value: "MDA" },
  { label: "Managed ExpertOps", value: "MEXO" },
  { label: "Premium Support", value: "PS" },
  { label: "Managed Governance", value: "CSM" },
  { label: "Managed Brownfield Landing Zone", value: "MBLZ" },
  { label: "Managed Network Service", value: "MNS" },
];
